<template>
  <v-card
    loader-height="8"
    :loading="admin.componentsLoading"
    :disabled="admin.componentsLoading"
    min-width="600"
    :min-height="minCardHeight"
    class=""
  >
    <v-dialog v-model="showConfirmationDialog" max-width="450">
      <v-card>
        <v-card-title
          ><v-icon class="mr-2" color="yellow darken-2"> mdi-alert </v-icon
          >CONFIRM</v-card-title
        >
        <v-card-text class="text-h5">
          Delete Component ({{ name }})?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="deleteComponent">
            <v-icon> mdi-check-bold </v-icon>
          </v-btn>
          <v-btn
            color="error lighten-1"
            @click="showConfirmationDialog = false"
          >
            <v-icon> mdi-cancel </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar color="blue darken-2" class="text-h4 text-uppercase" dark>
      {{ tabName }}
      <v-spacer></v-spacer>

      <v-icon>{{ app.componentIcon }}</v-icon>
    </v-toolbar>
    <v-card-text class="pt-4">
      <v-overlay :opacity="0.9" absolute :value="showSaveOverlay">
        <v-btn color="success"> Component saved </v-btn>
      </v-overlay>
      <v-form v-model="valid">
        <v-text-field
          outlined
          v-model="subsystemDefinitionId"
          label="Subsystem Definition ID"
          readonly
          disabled
        >
        </v-text-field>
        <v-text-field
          outlined
          v-model="name"
          :rules="validation.length50"
          label="Component Name"
          required
          autofocus
        ></v-text-field>
        <v-text-field
          outlined
          v-model="stepLabel"
          :rules="validation.length50"
          label="Step Label"
          required
        ></v-text-field>
        <v-text-field
          outlined
          v-model="description"
          :rules="validation.length250"
          label="Component Description"
          required
        ></v-text-field>
        <v-autocomplete
          outlined
          :items="admin.productTypeList"
          label="Product Type!"
          item-text="name"
          item-value="id"
          v-model="productTypeId"
        ></v-autocomplete>
        <v-autocomplete
          outlined
          :items="admin.attributeList"
          label="Default Qty from Setting"
          clearable
          item-text="name"
          item-value="id"
          v-model="defaultQuantityFromSetting"
        ></v-autocomplete>
        <v-text-field
          outlined
          v-model="maxQuantity"
          :rules="[...validation.numeric, ...validation.atLeastOne]"
          label="Max Quantity"
          required
        ></v-text-field>
        <v-text-field
          outlined
          v-model="sequence"
          :rules="validation.numeric"
          label="Sequence"
          required
        ></v-text-field>
        <v-textarea
          outlined
          v-model="sigMessage"
          :rules="validation.length1000"
          label="Sig Message"
        >
        </v-textarea>
        <v-checkbox
          color="blue darken-2"
          v-model="published"
          label="Published"
        ></v-checkbox>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        dark
        color="blue darken-2"
        @click="saveComponent"
        :disabled="!valid"
        >save</v-btn
      >
      <v-btn color="gray" @click="closeDialog">close</v-btn>
      <v-btn
        v-show="!isNaN(id)"
        icon
        color="error"
        @click="confirmDeleteComponent"
        ><v-icon>mdi-trash-can</v-icon></v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    props: {
      minCardHeight: Number
    },
    components: {},
    data() {
      return {
        showSaveOverlay: false,
        showConfirmationDialog: false,
        valid: false
      };
    },
    computed: {
      ...mapState(['app', 'admin']),
      tabName: {
        get() {
          return this.admin.selectedComponent &&
            this.admin.selectedComponent.id != 'new'
            ? `Edit Component [${this.name}]`
            : 'Add New Component';
        }
      },
      id: {
        get() {
          return this.admin.selectedComponent?.id;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedComponent',
            property: 'id',
            value: value
          });
        }
      },
      subsystemDefinitionId: {
        get() {
          return this.admin.selectedComponent?.subsystemDefinitionId;
        }
      },
      name: {
        get() {
          return this.admin.selectedComponent?.name;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedComponent',
            property: 'name',
            value: value
          });
        }
      },
      maxQuantity: {
        get() {
          return this.admin.selectedComponent?.maxQuantity;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedComponent',
            property: 'maxQuantity',
            value: Number(value)
          });
        }
      },
      description: {
        get() {
          return this.admin.selectedComponent?.description;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedComponent',
            property: 'description',
            value: value
          });
        }
      },
      stepLabel: {
        get() {
          return this.admin.selectedComponent?.stepLabel;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedComponent',
            property: 'stepLabel',
            value: value
          });
        }
      },
      productTypeId: {
        get() {
          return this.admin.selectedComponent?.productTypeId;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedComponent',
            property: 'productTypeId',
            value: Number(value)
          });
        }
      },
      sequence: {
        get() {
          return this.admin.selectedComponent?.sequence;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedComponent',
            property: 'sequence',
            value: Number(value)
          });
        }
      },
      sigMessage: {
        get() {
          return this.admin.selectedComponent?.sigMessage;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedComponent',
            property: 'sigMessage',
            value: value
          });
        }
      },
      defaultQuantityFromSetting: {
        get() {
          return this.admin.selectedComponent?.defaultQuantityFromSetting;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedComponent',
            property: 'defaultQuantityFromSetting',
            value: Number(value)
          });
        }
      },
      published: {
        get() {
          return this.admin.selectedComponent?.published;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedComponent',
            property: 'published',
            value: value
          });
        }
      }
    },
    methods: {
      /**
       * Cancels upsert of a component
       */
      closeDialog() {
        this.$store.commit('admin/setShowEditComponentDialog', false);
      },
      /**
       * Saves the component currently being edited
       */
      saveComponent() {
        this.$store.dispatch('admin/saveSelectedComponent').then(() => {
          this.showSaveOverlay = true;
          // refresh component list
          this.$store.dispatch(
            'admin/getComponentsBySubsystemId',
            this.admin.selectedSubsystem.id
          );
          setTimeout(() => {
            this.showSaveOverlay = false;
            this.$store.commit('admin/setShowEditComponentDialog', false);
          }, 1500);
        });
      },
      /**
       * Show confirm dialog
       */
      confirmDeleteComponent() {
        this.showConfirmationDialog = true;
      },
      /**
       * Deletes a component
       */
      deleteComponent() {
        this.$store
          .dispatch('admin/deleteSelectedComponent', this.id)
          .then(() => {
            this.$store.dispatch(
              'admin/getComponentsBySubsystemId',
              this.admin.selectedSubsystem.id
            );
            this.showConfirmationDialog = false;
            this.$store.commit('admin/setSelectedComponent', null);
          });
      }
    }
  };
</script>

<style scoped></style>
